import { ParceriasPrograma } from 'src/app/core/parcerias-programa';
export class AditivoParceriaPrograma {

	id:number;
	parceriasPrograma:ParceriasPrograma;
	dataAditivo:Date;
	valorAditivo:number;
}